import React from "react";
import { Redirect, Route } from "react-router-dom";
import * as FeatherIcon from "react-feather";

import { store } from "../redux/store";

// dashboard
const Dashboard = React.lazy(() => import("../pages/dashboard/Dashboard"));

// archive
const Archive = React.lazy(() => import("../pages/archive/Archive"));
const DetailArchive = React.lazy(() =>
  import("../pages/archive/DetailArchiveV2")
);

// loan
const Loan = React.lazy(() => import("../pages/loan/LoanV2"));
const DetailLoan = React.lazy(() => import("../pages/loan/DetailLoanV2"));

// pre-fund
const PreFund = React.lazy(() => import("../pages/pre_fund/PreFundV2"));
const DetailPreFund = React.lazy(() =>
  import("../pages/pre_fund/DetailPreFundV2")
);
const StatusUploadSFTP = React.lazy(() => import("../pages/pre_fund/StatusUploadSFTP"));


// diburse
const Disburse = React.lazy(() => import("../pages/disburse/DisburseV2"));

// payment
const Payment = React.lazy(() => import("../pages/payment/Repayment"));
const DetailPayment = React.lazy(() =>
  import("../pages/payment/DetailRepaymentV2")
);

// advance diburse
const AdvDisburse = React.lazy(() => import("../pages/adv_disburse/AdvDisburse"));
const DetailAdvDisburse = React.lazy(() => import("../pages/adv_disburse/DetailAdvDisburse"));

// collection
const Collection = React.lazy(() => import("../pages/collection/Collection"));
const DetailCollection = React.lazy(() =>
  import("../pages/collection/DetailCollectionV2")
);

// declined
const Declined = React.lazy(() => import("../pages/declined/Declined"));
const DetailDeclined = React.lazy(() => import("../pages/declined/DetailDeclined"));

// SO
const SendingOrganization = React.lazy(() => import("../pages/so/SendingOrganization"));
const DetaiilSendingOrganization = React.lazy(() => import("../pages/so/DetailSendingOrganization"));

// Lender Channeling
const LenderChanneling = React.lazy(() => import("../pages/lender/channeling/Channeling"));
const DetailLenderChanneling = React.lazy(() => import("../pages/lender/channeling/DetailChanneling"));

// Access Management
const AccessManagement = React.lazy(() => import("../pages/manage_access/ManageAccess"));

// Lender Management
const LenderManagement = React.lazy(() => import("../pages/lender_management/LenderManagement"));

// Member
const Member = React.lazy(() => import("../pages/member/Member"));

// Member
const BorrowerManagement = React.lazy(() => import("../pages/borrower_management/BorrowerManagement"));

// auth
const Login = React.lazy(() => import("../pages/auth/Login"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));

// 404
const NotFound = React.lazy(() => import("../pages/other/Error404"));


// pre approval
const Approval = React.lazy(() => import("../pages/pre-approval/presentation/Approval"));
const DetailApproval = React.lazy(() => import("../pages/pre-approval/presentation/Detail"));


// handle auth and authorization
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    const { user } = store.getState().Auth;
    return (
        <Route
            {...rest}
            render={(props) => {
                if (user === null) {
                    // not logged in so redirect to login page with the return url
                    return <Redirect to={{ pathname: "/account/login", state: { from: props.location } }} />;
                }

                // const loggedInUser = getLoggedInUser();
                // // check if route is restricted by role
                // if (roles && roles.indexOf(loggedInUser.role) === -1) {
                //     // role not authorised so redirect to home page
                //     return <Redirect to={{ pathname: '/' }} />;
                // }

                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

// root routes
const rootRoute = {
  path: "/",
  exact: true,
  component: () => <Redirect to="/dashboard" />,
  route: PrivateRoute,
};

// not found route
const notFoundRoute = {
  path: "*",
  exact: true,
  component: NotFound,
  route: Route,
};

// dashboard
const dashboardRoutes = {
  path: "/dashboard",
  exact: true,
  name: "Dashboard",
  icon: FeatherIcon.Home,
  component: Dashboard,
  roles: ["Admin"],
  route: PrivateRoute,
};

// archive
const archiveRoutes = {
  menu_id: "06",
  path: "/archive",
  exact: true,
  name: "Arsip",
  icon: FeatherIcon.Archive,
  component: Archive,
  roles: ["Admin"],
  route: PrivateRoute,
};
const detailArchiveRoutes = {
  //access_id : "01-1",
  path: "/archive/detail/:loanId",
  exact: true,
  component: DetailArchive,
  roles: ["Admin"],
  route: PrivateRoute,
};

// loan routes
const loanRoutes = {
  menu_id: "01",
  path: "/loan",
  exact: true,
  name: "Pinjaman",
  icon: FeatherIcon.Inbox,
  component: Loan,
  roles: ["Admin"],
  route: PrivateRoute,
};
const detailLoanRoutes = {
  path: "/loan/detail/:loanId",
  exact: true,
  component: DetailLoan,
  roles: ["Admin"],
  route: PrivateRoute,
};

// pre-fund routes
const preDisburseDetailRoutes = {
  path: "/pre-disburse/detail/:loanId",
  exact: true,
  component: DetailPreFund,
  roles: ["Admin"],
  route: PrivateRoute,
};

const PreDisburseRoutes = {
  menu_id: "05",
  name: "Pra-Pencairan",
  icon: FeatherIcon.AtSign,
  children: [
    {
      menu_id: "05.1",
      path: "/pre-disburse",
      exact: true,
      name: "Daftar Peminjam",
      icon: null,
      component: PreFund,
      roles: ["Admin"],
      route: PrivateRoute,
    },
    {
      menu_id: "05.2",
      path: "/pre-disburse-sftp",
      exact: true,
      name: "Status Upload Ganesha",
      icon: null,
      component: StatusUploadSFTP,
      roles: ["Admin"],
      route: PrivateRoute,
    },
  ],
};

// disburse
const diburseRoutes = {
  menu_id: "04",
  path: "/disburse",
  exact: true,
  name: "Pencairan",
  icon: FeatherIcon.Share,
  component: Disburse,
  roles: ["Admin"],
  route: PrivateRoute,
};

// payment
const paymentRoutes = {
  menu_id: "02",
  path: "/payment",
  exact: true,
  name: "Pembayaran",
  icon: FeatherIcon.Pocket,
  component: Payment,
  roles: ["Admin"],
  route: PrivateRoute,
};

const detailpaymentRoutes = {
  path: "/payment/detail/:loanId",
  exact: true,
  component: DetailPayment,
  roles: ["Admin"],
  route: PrivateRoute,
};

// advance disburse routes
const advDiburseRoutes = {
  menu_id: "08",
  path: "/adv-disburse",
  exact: true,
  name: "Upload Dokumen",
  icon: FeatherIcon.UploadCloud,
  component: AdvDisburse,
  roles: ["Admin"],
  route: PrivateRoute,
};
const advDiburseDetailRoutes = {
  path: "/adv-disburse/detail/:loanId",
  exact: true,
  component: DetailAdvDisburse,
  roles: ["Admin"],
  route: PrivateRoute,
};

// collection
const collectionRoutes = {
  menu_id: "03",
  path: "/collection",
  exact: true,
  name: "Penagihan",
  icon: FeatherIcon.Archive,
  component: Collection,
  roles: ["Admin"],
  route: PrivateRoute,
};
const detailCollectionRoutes = {
  path: "/collection/detail/:loanId",
  exact: true,
  component: DetailCollection,
  roles: ["Admin"],
  route: PrivateRoute,
};

// declined
const declinedRoutes = {
  menu_id: "07",
  path: "/declined",
  exact: true,
  name: "Reject",
  icon: FeatherIcon.FileMinus,
  component: Declined,
  roles: ["Admin"],
  route: PrivateRoute,
};

const detailDeclinedRoutes = {
  //access_id : "01-1",
  path: "/declined/detail/:loanId",
  exact: true,
  component: DetailDeclined,
  roles: ["Admin"],
  route: PrivateRoute,
};

//SO
const sendingOrgRoutes = {
    menu_id: "10",
    path: "/lpk",
    exact: true,
    name: "LPK",
    icon: FeatherIcon.List,
    component: SendingOrganization,
    roles: ["Admin"],
    route: PrivateRoute,
};

const detailsendingOrgRoutesRoutes = {
  path: "/lpk/detail/:companyId",
  exact: true,
  component: DetaiilSendingOrganization,
  roles: ["Admin"],
  route: PrivateRoute,
};

const lenderChannelingRoutes = {
  menu_id: "09",
  name: "Lender",
  icon: FeatherIcon.Briefcase,
  children: [
    {
      name: "Pembayaran",
      children: [
        {
          path: "/lender/channeling",
          exact: true,
          name: "Channeling",
          component: LenderChanneling,
          roles: ["Admin"],
          route: PrivateRoute,
        },
        {
          path: "/lender/channeling/detail/:loanId",
          exact: true,
          component: DetailLenderChanneling,
          roles: ["Admin"],
          route: PrivateRoute,
        },
      ],
    },
  ],
};

// Access Management
const manageAccessRoutes = {
  menu_id: "00-1",
  path: "/management/access",
  exact: true,
  component: AccessManagement,
  roles: ["Admin"],
  route: PrivateRoute,
};

// Lender Management
const manageLenderRoutes = {
  menu_id: "11",
  path: "/lender/management",
  exact: true,
  name: "Lender Management",
  icon: FeatherIcon.User,
  component: LenderManagement,
  roles: ["Admin"],
  route: PrivateRoute,
};

// Member
const memberRoutes = {
  menu_id: "12",
  path: "/member",
  exact: true,
  name: "Daftar Anggota",
  icon: FeatherIcon.Users,
  component: Member,
  roles: ["Admin"],
  route: PrivateRoute,
};

// Borrower Management
const manageborrowerRoutes = {
  menu_id: "00-2",
  path: "/management/borrower",
  exact: true,
  component: BorrowerManagement,
  roles: ["Admin"],
  route: PrivateRoute,
};

const PreApprovalRoutes = {
  menu_id: "13",
  path: "/pre-approval",
  exact: true,
  name : "Pre-Approval",
  icon: FeatherIcon.Inbox,
  component: Approval,
  roles: ["Admin"],
  route: PrivateRoute,
};

const DetailApprovalRoutes = {
  path: "/pre-approval/:loanId",
  exact: true,
  component: DetailApproval,
  roles: ["Admin"],
  route: PrivateRoute,
}


// auth
const authRoutes = {
  path: "/account",
  exact: true,
  name: "Auth",
  children: [
    {
      path: "/account/login",
      exact: true,
      name: "Login",
      component: Login,
      route: Route,
    },
    {
      path: "/account/logout",
      exact: true,
      name: "Logout",
      component: Logout,
      route: Route,
    },
  ],
};

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
  let flatRoutes = [];

  routes = routes || [];
  routes.forEach((item) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const allRoutes = [
  rootRoute,
  dashboardRoutes,
  archiveRoutes,
  detailArchiveRoutes,
  PreApprovalRoutes,
  loanRoutes,
  detailLoanRoutes,
  PreDisburseRoutes,
  preDisburseDetailRoutes,
  diburseRoutes,
  advDiburseRoutes,
  advDiburseDetailRoutes,
  collectionRoutes,
  detailCollectionRoutes,
  paymentRoutes,
  detailpaymentRoutes,
  lenderChannelingRoutes,
  declinedRoutes,
  detailDeclinedRoutes,
  sendingOrgRoutes,
  detailsendingOrgRoutesRoutes,
  manageAccessRoutes,
  manageLenderRoutes,
  memberRoutes,
  manageborrowerRoutes,
  authRoutes,
  DetailApprovalRoutes,
  notFoundRoute,
];

const authProtectedRoutes = [
  dashboardRoutes,
  archiveRoutes,
  detailArchiveRoutes,
  PreApprovalRoutes,
  loanRoutes,
  detailLoanRoutes,
  PreDisburseRoutes,
  preDisburseDetailRoutes,
  diburseRoutes,
  advDiburseRoutes,
  advDiburseDetailRoutes,
  paymentRoutes,
  detailpaymentRoutes,
  collectionRoutes,
  detailCollectionRoutes,
  lenderChannelingRoutes,
  manageAccessRoutes,
  manageLenderRoutes,
  declinedRoutes,
  detailDeclinedRoutes,
  sendingOrgRoutes,
  detailsendingOrgRoutesRoutes,
  memberRoutes,
  manageborrowerRoutes,
  DetailApprovalRoutes,
];
const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };